import React, { Fragment } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Recharts from "./Recharts";
import DevextremeMap from "./DevextremeMap";
import Country from "./Country";
import Allset from "./Allset";
import Test from "./Test";
import Filter from "./Filter";
import Axiostest from "./Axiostest";
import Map from "./Map";
import API from "./API";
import Dmpricing from "./Dmpricing";
import Segment from "./Segment";
import OptimisedSegment from "./OptimisedSegment";
import Sirji from "./Sirji";
import DGrid from "./DGrid";
import TestData from "./TestData";
import ArrayPractise from "./ArrayPractise";
import Parent from "./Parent";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
   <Parent/>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
